/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'abiprufung': {
    width: 34,
    height: 35,
    viewBox: '0 0 34 35',
    data: `<desc>Created using Figma</desc><use xlink:href="#svgicon-abiprufung-a" transform="rotate(-90 17 17)" fill="#F5D78B"/><use xlink:href="#svgicon-abiprufung-b" transform="translate(9 9)" fill="#F77261"/><defs><path pid="0" id="svgicon-abiprufung-a" fill-rule="evenodd" d="M33.971 18c.02-.331.029-.664.029-1 0-9.389-7.611-17-17-17S0 7.611 0 17s7.611 17 17 17c.336 0 .67-.01 1-.03V18h15.971z"/><path pid="1" id="svgicon-abiprufung-b" d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0z"/></defs>`
  }
})
